import { allowanceCents, isBetaWriter } from './betaAllowance';

/**
 * Beta AI spend pauses at $0 or after a provisioned 402.
 * Own-key accounts are never paused here. An unknown balance does not
 * count as zero: a failed read keeps the last good figure (#1477).
 */
let latest = null;
let provisioned402 = false;
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* a listener must not block the pause */
    }
  });
}

export function publishAllowance(data) {
  latest = data && typeof data === 'object' ? data : null;
  if (isBetaWriter(latest)) {
    const balance = Number(latest.balance);
    if (Number.isFinite(balance) && allowanceCents(balance) > 0) {
      provisioned402 = false;
    }
  }
  emit();
}

export function noteBeta402(source) {
  const provisioned = Boolean(
    source?.provisioned
    ?? source?.detail?.provisioned
    ?? source?.error?.provisioned,
  );
  if (!provisioned) return;
  provisioned402 = true;
  emit();
}

export function betaAiPaused() {
  if (latest?.key_provisioning === 'own_needed') return true;
  if (latest && !isBetaWriter(latest)) return false;
  if (provisioned402) return true;
  if (!isBetaWriter(latest)) return false;
  // null is an unknown read, not zero. Number(null) is 0, so check first.
  if (latest.balance == null || latest.balance === '') return false;
  const balance = Number(latest.balance);
  if (!Number.isFinite(balance)) return false;
  return allowanceCents(balance) === 0;
}

export function subscribeBetaSpend(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function resetBetaSpendForTests() {
  latest = null;
  provisioned402 = false;
  listeners.clear();
}
